import { useRouteMatch, Route, Switch } from 'react-router-dom';
import { useIntl } from 'react-intl';

import LayoutWrapper from '../components/layout/LayoutWrapper';
import useAutoformMetadata from '../components/autoform/hooks/useAutoformMetadata';
import SidebarItemListContainer from '../components/autoform/SidebarItemListContainer';
import LoadingModal from '../components/utils/LoadingModal';
import Autoform from '../components/autoform/Autoform';

import autoformPlaceholder from '../images/autoform-unselected.png';
import WrapperEmptyState from '../components/layout/WrapperEmptyState';
import useAutoformLoadMetadata from '../components/autoform/hooks/useAutoformLoadMetadata';

const AutoformPage = () => {
    const intl = useIntl();
    const { metadata, hierarchicalTables } = useAutoformMetadata();
    let {
        path,
        params: { autoformId },
    } = useRouteMatch();
    const { isLoading } = useAutoformLoadMetadata(autoformId);

    const level1TableId = hierarchicalTables.level1[0]?.id;

    if (!metadata || isLoading) {
        return <LoadingModal header={intl.formatMessage({ id: 'autoform_loading_modal_message' })} isOpen />;
    }

    return (
        <LayoutWrapper
            sidebar={
                metadata.maxTableHierarchyLevel > 1 && (
                    <SidebarItemListContainer schemaCode={metadata.schemaCode} tableId={level1TableId} />
                )
            }
            content={
                metadata.maxTableHierarchyLevel > 1 ? (
                    <Switch>
                        <Route exact path={path}>
                            <WrapperEmptyState imgSrc={autoformPlaceholder} page="item" noun="properties" />
                        </Route>

                        <Route path={`${path}/:itemId`}>
                            <Autoform />
                        </Route>
                    </Switch>
                ) : (
                    <Autoform />
                )
            }
        />
    );
};

export default AutoformPage;
